import documentTemplatesApiService from '@/services/api/DocumentTemplates'

const TYPE_OFFER = 'offer'
const TYPE_CONTRACT = 'contract'
const TYPE_ORDER = 'order'
const TYPE_INVESTMENT_PROGRAM = 'investment_program'

const emptyModel = {
  title: null,
  description: null,
  editable: true,
  type: TYPE_CONTRACT,
  text: null,
  countries: [],
  finance_models: []
}

class DocumentTemplate {
  constructor() {
    this.api = documentTemplatesApiService
    this.emptyModel = emptyModel
    this.TYPE_OFFER = TYPE_OFFER
    this.TYPE_CONTRACT = TYPE_CONTRACT
    this.TYPE_ORDER = TYPE_ORDER
    this.TYPE_INVESTMENT_PROGRAM = TYPE_INVESTMENT_PROGRAM
  }
}

const documentTemplate = new DocumentTemplate()

export default documentTemplate
